// import React from 'react';
// import PromoSidebar from "../../../PromoSidebar/PromoSidebar";
//  import BlogNavigator from '../../../BlogNavigator/BlogNavigator.js';
// import { travelBlogs } from '../Travelinternational.js';
// import './thailand-tropical-escape.css';
// import img1 from "./thailand.webp";
// import img2 from "./Bangkok.webp";
// import img3 from "./Phuket.webp";
// import img4 from "./Chiang Mai.webp";
// import img5 from "./Krabi.webp";
// import img6 from "./floating markets.webp";
// import img7 from "./PhiPhi (1).webp";

// export default function ThailandBlogPage() {
//   return (
//     <section className="thailand-page">
//       {/* HERO SECTION */}
//       <div className="hero">
//         <img
//           src={img1}
//           alt="Thailand tropical paradise"
//           className="hero-img"
//         />
//         <div className="hero-overlay">
//           <h1 className="hero-title">Thailand: Tropical Paradise Awaits</h1>
//           <p className="hero-subtitle">
// From Bangkok’s buzzing streets to Phuket’s golden beaches and Chiang Mai’s serene temples — discover the vibrant culture, exotic flavors, and breathtaking beauty that make Thailand every traveler’s dream.          </p>
//         </div>
//       </div>

//       {/* INTRO SECTION */}
//       <div className="intro container">
//         <p>
//          From the electrifying nightlife of Bangkok to the sun-kissed shores of Phuket and the tranquil temples of Chiang Mai, Thailand unfolds like a dream for every traveler. Immerse yourself in its vibrant culture, mouth-watering street food, and breathtaking tropical landscapes — a perfect blend of adventure, relaxation, and timeless tradition that makes Thailand truly unforgettable.
//         </p>
//       </div>

//       {/* HIGHLIGHT GRID */}
//       <div className="highlights container">
//         <div className="highlight-card">
//           <img src={img2} alt="Bangkok nightlife" />
//           <h3>Bangkok</h3>
//           <p>Experience nightlife, street food & cultural wonders.</p>
//         </div>
//         <div className="highlight-card">
//           <img src={img3} alt="Phuket beaches" />
//           <h3>Phuket</h3>
//           <p>Soak in the sun on golden beaches & enjoy water sports.</p>
//         </div>
//         <div className="highlight-card">
//           <img src={img4} alt="Chiang Mai temples" />
//           <h3>Chiang Mai</h3>
//           <p>Discover ancient temples & the peaceful northern vibe.</p>
//         </div>
//         <div className="highlight-card">
//           <img src={img5} alt="Krabi islands" />
//           <h3>Krabi</h3>
//           <p>Unwind on stunning islands & crystal-clear waters.</p>
//         </div>
//       </div>

//       {/* EXPERIENCE SECTION */}
//       <div className="experience container">
//         <div className="experience-row">
         
//           <div className="exp-text">
//             <h2>Culture & Local Life</h2>
//              <div className="exp-img">
//             <img src={img6} alt="Floating market" />
//           </div>
//             <p>
//               Immerse yourself in the heart of Thai culture, where floating markets ripple with color, festivals glow with joy, and every smile tells a story of warmth and community. From local traditions to timeless hospitality, experience the soul of Thailand’s local life in its most authentic form.
//             </p>
//           </div>
//         </div>

//         <div className="experience-row reverse">
          
//           <div className="exp-text">
//             <h2>Adventure & Serenity</h2>
//             <div className="exp-img">
//             <img src={img7} alt="Island adventure" />
//           </div>
//             <p>
//               From diving into the crystal-clear waters of Phi Phi Islands to finding peace in Chiang Rai’s serene temples, Thailand offers the perfect harmony of adventure and tranquility — a paradise where every moment feels beautifully balanced.
//             </p>
//           </div>
          
//         </div>
//       </div>

//       {/* TIPS + SIDEBAR SECTION */}
//      <div className="tips-wrapper container">
//   <div className="tips">
//     <h2>Essential Travel Tips for Thailand</h2>
// <ul>
//   <li><strong>Best time to visit:</strong> Plan your Thailand trip between <strong>November and March</strong> for perfect weather and vibrant festivals.</li>
//   <li> <strong>Must-try dishes:</strong> Treat your taste buds to <strong>Pad Thai</strong>, <strong>Mango Sticky Rice</strong>, and refreshing <strong>Thai Iced Tea</strong>.</li>
//   <li> <strong>Temple etiquette:</strong> Dress modestly, remove shoes before entering, and show respect for sacred spaces.</li>
//   <li> <strong>Top experiences:</strong> Explore the turquoise waters with <strong>island-hopping tours in Krabi and Phuket</strong> — a true tropical delight.</li>
// </ul>

//   </div>



//   <aside className="tips-sidebar">
//     <PromoSidebar/>
//   </aside>
// </div>
// <BlogNavigator
//                   category="Travelinternational"
//                   blogs={travelBlogs}
//                   currentBlogId="thailand-tropical-escape"
//                 />

//     </section>
//   );
// }

import React from 'react';
import PromoSidebar from "../../../PromoSidebar/PromoSidebar";
import BlogNavigator from '../../../BlogNavigator/BlogNavigator.js';
import { travelBlogs } from '../Travelinternational.js';
import styles from './thailand-tropical-escape.module.css';
import CTASection from "../../../../CTASection/CTASection";

import img1 from "./thailand.webp";
import img2 from "./Bangkok.webp";
import img3 from "./Phuket.webp";
import img4 from "./Chiang Mai.webp";
import img5 from "./Krabi.webp";
import img6 from "./floating markets.webp";
import img7 from "./PhiPhi (1).webp";

export default function ThailandBlogPage() {
  return (
    <section className={styles.thailandPage}>

      {/* HERO SECTION */}
      <div className={styles.hero}>
        <img
          src={img1}
          alt="Thailand tropical paradise"
          className={styles.heroImg}
        />
        <div className={styles.heroOverlay}>
          <h1 className={styles.heroTitle}>Thailand: Tropical Paradise Awaits</h1>
          <p className={styles.heroSubtitle}>
            From Bangkok’s buzzing streets to Phuket’s golden beaches and Chiang Mai’s serene temples — discover the vibrant culture, exotic flavors, and breathtaking beauty that make Thailand every traveler’s dream.
          </p>
        </div>
      </div>

      {/* INTRO SECTION */}
      <div className={`${styles.intro} ${styles.container}`}>
        <p>
          From the electrifying nightlife of Bangkok to the sun-kissed shores of Phuket and the tranquil temples of Chiang Mai, Thailand unfolds like a dream for every traveler. Immerse yourself in its vibrant culture, mouth-watering street food, and breathtaking tropical landscapes — a perfect blend of adventure, relaxation, and timeless tradition that makes Thailand truly unforgettable.
        </p>
      </div>

      {/* HIGHLIGHT GRID */}
      <div className={`${styles.highlights} ${styles.container}`}>
        <div className={styles.highlightCard}>
          <img src={img2} alt="Bangkok nightlife" />
          <h3>Bangkok</h3>
          <p>Experience nightlife, street food & cultural wonders.</p>
        </div>

        <div className={styles.highlightCard}>
          <img src={img3} alt="Phuket beaches" />
          <h3>Phuket</h3>
          <p>Soak in the sun on golden beaches & enjoy water sports.</p>
        </div>

        <div className={styles.highlightCard}>
          <img src={img4} alt="Chiang Mai temples" />
          <h3>Chiang Mai</h3>
          <p>Discover ancient temples & the peaceful northern vibe.</p>
        </div>

        <div className={styles.highlightCard}>
          <img src={img5} alt="Krabi islands" />
          <h3>Krabi</h3>
          <p>Unwind on stunning islands & crystal-clear waters.</p>
        </div>
      </div>
       <CTASection
  heading="Thinking About a Thai Getaway?"
  description="Beaches, nightlife, adventure—Thailand has everything for your perfect holiday. Let’s plan your tropical escape."
  buttonText="Book Your Thailand Trip"
  buttonLink="tel:+919876543210"
/>
      {/* EXPERIENCE SECTION */}
      <div className={`${styles.experience} ${styles.container}`}>

        <div className={styles.experienceRow}>
          <div className={styles.expText}>
            <h2>Culture & Local Life</h2>

            <div className={styles.expImg}>
              <img src={img6} alt="Floating market" />
            </div>

            <p>
              Immerse yourself in the heart of Thai culture, where floating markets ripple with color, festivals glow with joy, and every smile tells a story of warmth and community.
            </p>
          </div>
        </div>

        <div className={`${styles.experienceRow} ${styles.reverse}`}>
          <div className={styles.expText}>
            <h2>Adventure & Serenity</h2>

            <div className={styles.expImg}>
              <img src={img7} alt="Island adventure" />
            </div>

            <p>
              From diving into the crystal-clear waters of Phi Phi Islands to finding peace in Chiang Rai’s serene temples, Thailand offers the perfect harmony of adventure and tranquility — a paradise where every moment feels beautifully balanced.
            </p>
          </div>
        </div>
      </div>

      {/* TIPS + SIDEBAR */}
      <div className={`${styles.tipsWrapper} ${styles.container}`}>
        <div className={styles.tips}>
          <h2>Essential Travel Tips for Thailand</h2>

          <ul>
            <li><strong>Best time to visit:</strong> November to March.</li>
            <li><strong>Must-try dishes:</strong> Pad Thai, Mango Sticky Rice, Thai Iced Tea.</li>
            <li><strong>Temple etiquette:</strong> Dress modestly, remove shoes.</li>
            <li><strong>Top experiences:</strong> Island hopping in Krabi & Phuket.</li>
          </ul>
        </div>

        <aside className={styles.tipsSidebar}>
          <PromoSidebar />
        </aside>
      </div>

      <BlogNavigator
        category="Travelinternational"
        blogs={travelBlogs}
        currentBlogId="thailand-tropical-escape"
      />

    </section>
  );
}
